import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dialog-window',
  templateUrl: './dialog-window.component.html'
})
export class DialogWindowComponent {
  @Input() leftButton: string = 'no';
  @Input() rightButton: string = 'yes';

  public title: string;
  public message: string;

  constructor(private translate: TranslateService, @Inject(MAT_DIALOG_DATA) public data: any) {
    if (data.leftButton) this.leftButton = data.leftButton;
    if (data.rightButton) this.rightButton = data.rightButton;
    if (data.title) this.title = this.translate.instant(data.title, data.titleParams);
    if (data.message) this.message = this.translate.instant(data.message, data.messageParams);
  }
}
